import { render, staticRenderFns } from "./forwarding.vue?vue&type=template&id=78e4ff4a&scoped=true&"
import script from "./forwarding.vue?vue&type=script&lang=js&"
export * from "./forwarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e4ff4a",
  null
  
)

export default component.exports